import {
    h,
    type Component,
    type Ref,
    type ComponentPublicInstance
} from 'vue';
import type { InferComponentProps } from '../../types';

export const createAppComponent = <T extends Component>(
    component: T,
    componentRef: Ref<ComponentPublicInstance<any>>,
    destroy: () => void,
    componentProps?: InferComponentProps<T>
) => ({
    setup() {
        return () => h(component, {
            ...componentProps,
            destroy,
            ref: componentRef,
        });
    },
});